'use strict';
var parent = require('../../actual/object/get-own-property-descriptors');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/object/get-own-property-descriptors.js
// module id = 634
// module chunks = 13